import { useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate } from "react-router-dom";
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Tooltip,
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import PersonIcon from '@mui/icons-material/Person';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import RefreshIcon from '@mui/icons-material/Refresh';
import DeleteIcon from '@mui/icons-material/Delete';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { OrdersHeader, roleColor } from './orderData';
import { IOrderHeader } from '../../interface/IOrders_Tasks';
import { ITaskStatus } from '../../interface/ITask';
import { AxiosInstance } from '../../api/apiInstance';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import { muiTableBodyCellPropsHelper, muiTableHeadCellPropsHelper } from '../../helper/helper';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { Stack } from 'react-bootstrap';
import UsersDialog from './usersDialog';




const Orders = () => {
  const LocalUserRoleId = useRef(0);
  const userinfo: IUser = useSelector((state: any) => state.user)
  const taskStatus: ITaskStatus[] = useSelector((state: any) => state.taskStatus)
  const taskUsers: IUser[] = useSelector((state: any) => state.allUsers)
  const navigate = useNavigate();
  const [showComlete, setShowComlete] = useState(false)
  const [openUsers, setOpenUsers] = useState(false);
  const [usersRowId, setUsersRowId] = useState('');
  
  const [searchBasketTxt, setSearchBasketTxt] = useState('')

  
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(undefined);
  const isFirstRender = useRef(true);
  useEffect(() => {
    const tmpGlobalFilter = sessionStorage.getItem('mrt_globalFilter_table_1');
    if (tmpGlobalFilter) {
      setGlobalFilter(JSON.parse(tmpGlobalFilter) || undefined);
    }   
    isFirstRender.current = false;
  }, [])

  useEffect(() => {
    if (isFirstRender.current) return;
    if (globalFilter === undefined) return;
    sessionStorage.setItem(
      'mrt_globalFilter_table_1',
      JSON.stringify(globalFilter ?? ''),
    );
  }, [globalFilter]);

  const resetState = () => {

    sessionStorage.removeItem('mrt_globalFilter_table_1');
    setGlobalFilter('');
    //refetch();
  };

  function _handleShowComleteChange(e: any) {

    setShowComlete(!showComlete)
    sleep(50);
    refetch();
  }

  const handleOpenReassignUser = async (row: any) => {
    // const setUser =
    // {
    //   user: { id: 1 }
    // }
    // await AxiosInstance.patch('order/updateData/' + row.id, setUser)
    //   .then(function (response) {
    //   })
    //   .catch(function (error) {
    //     console.log(error);
    //   });
    // refetch();    
    setUsersRowId(row.id);
    setOpenUsers(true);

  }
  const handleReassignUser = async (rowId: any, user: any) => {
      
      const setUser =
      {
        user: { id: user }
      }
      await AxiosInstance.patch('order/updateData/' + rowId, setUser)
        .then(function (response) {
        })
        .catch(function (error) {
          console.log(error);
        });
      refetch();
      setOpenUsers(false);
  
    }
  const _handlePriority = async (row: any) => {
    const setPriority =
    {
      priorityOrder: 1
    }
    await AxiosInstance.patch('order/updateData/' + row.id, setPriority)
      .then(function (response) {
      })
      .catch(function (error) {
        console.log(error);
      });
    refetch();
  }



  function getUserColor(userName: string) {

    const res = taskUsers.find((usr) => {
      if (usr.userName === userName)
        return true;
      return false;
    })
    const select = res ? res.color ? res.color : 'grey' : 'grey'
    return select
  }
  function gettaskStatusColor(statusName: string) {
    const res = taskStatus.find((tsk) => {
      if (tsk.status === statusName)
        return true;
      return false;
    })
    return res ? res.color : 'grey'
  }
  function gettaskRoleColor(roleName: string) {
    const res = roleColor.find((tsk) => {
      if (tsk.roleName === roleName)
        return true;
      return false;
    })
    return res ? res.color : 'grey'
  }
  function searchBasketGotoOrder(e: any) {
    
    setSearchBasketTxt(e.target.value);
  }

  async function onKeysearchBasketGotoOrder(event: any) {
    //alert(JSON.stringify(userinfo.userRoleId));
    
    if (event.keyCode === 13) {
      const res = await AxiosInstance({
        // url of the api endpoint (can be changed)
        url: "order/getOrderByBasket/" +searchBasketTxt + "/" + userinfo.userRoleId,
        method: "GET",
      }).then(async (res) => {
        return res.data
      });
      if(res === '')
      {
        alert('No order found please locate manualy')
        
      }
      else{
        navigate('orderlines/' + res.id);
        
      }
    }
  }
  

  const sleep = (ms: number) =>
    new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    if (userinfo.userRoleName === 'Administrator') {
      setIsAdmin(true);
    }
    else {
      setIsAdmin(false);

    }
    LocalUserRoleId.current = userinfo.userRoleId
    refetch();
  },
    [userinfo.userRoleId])

  const columns = useMemo<MRT_ColumnDef<IOrderHeader>[]>(
    () => [
      {
        accessorKey: 'CUSTNAME',
        header: 'Customer name',
        enableEditing: false,
      },
      {
        accessorKey: 'ORDNAME',
        header: 'order name',
        enableEditing: false,
        size: 60,
      },
      {
        accessorKey: 'DETAILS',
        header: 'Details',
        enableEditing: false,
        size: 60,
      },
      {
        accessorKey: 'OrderLineItemsCount',
        header: 'Items',
        enableEditing: false,
        size: 30,
      },
      {
        accessorKey: 'STDES',
        header: 'shipping method',
        enableEditing: false,
        size: 60,
      },

      {
        accessorKey: 'CURDATE',
        header: 'order date',
        enableEditing: false,
        size: 60,
      },
      {
        accessorKey: '3PDate',
        header: '3p Date',
        enableEditing: false,
        size: 60,
      },
      {
        accessorKey: 'Pallet',
        header: 'Pallet',
        enableEditing: false,
        size: 30,
      },
      {
        accessorKey: 'COUNTRYNAME',
        header: 'Country',
        enableEditing: false,
        size: 60,
      },
      {
        accessorKey: 'role',
        header: 'Stage ',
        size: 60,
        // muiEditTextFieldProps: {
        //   required: true,
        //   error: !!validationErrors?.OrderInfo,
        //   helperText: validationErrors?.OrderInfo,
        //   //remove any previous validation errors when Order focuses on the input
        //   onFocus: () =>
        //     setValidationErrors({
        //       ...validationErrors,
        //       OrderInfo: undefined,
        //     }),
        // },
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: gettaskRoleColor(cell.getValue<string>()),
              borderRadius: '0.25rem',
              color: 'black',

              Width: 16,
              p: '0.5rem',
            })}
          >
            {cell.getValue<string>()}
          </Box>
        ),
      },
      {
        accessorKey: 'status',
        header: 'Status',
        editVariant: 'select',
        size: 60,
        editSelectOptions: taskStatus.map(taskStatus => taskStatus.status),
        muiEditTextFieldProps: {
          select: true,
          error: !!validationErrors?.state,
          helperText: validationErrors?.state,
        },
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: gettaskStatusColor(cell.getValue<string>()),
              borderRadius: '0.25rem',
              color: 'black',

              Width: 16,
              p: '0.5rem',
            })}
          >
            {cell.getValue<string>()}
          </Box>
        ),
      },

      {
        accessorKey: 'userName',
        header: 'user Name',
        editVariant: 'select',
        size: 50,
        editSelectOptions: taskUsers.map(tsu => tsu.userName),
        muiEditTextFieldProps: {
          select: true,
          error: !!validationErrors?.userName,
          helperText: validationErrors?.userName,
        },
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: getUserColor(cell.getValue<string>()),
              borderRadius: '0.25rem',
              color: 'black',

              Width: 16,
              p: '0.5rem',
            })}
          >
            {cell.getValue<string>() ? cell.getValue<string>() : 'assigned'}
          </Box>
        ),

      },

    ],
    [validationErrors],
  );

  //call CREATE hook
  // const { mutateAsync: createOrder, isPending: isCreatingOrder } =
  //   useCreateOrder();
  //call READ hook
  const {
    data: fetchedOrders = [],
    isError: isLoadingOrdersError,
    isFetching: isFetchingOrders,
    isLoading: isLoadingOrders,
    refetch,
  } = useGetOrders();
  async function SyncData() {
    
    await AxiosInstance({
      // url of the api endpoint (can be changed)
      url: "get-order-info",
      method: "GET",
    }).then(async (res) => {
    });
    await sleep(50);
    refetch();
  }
  //DELETE hook (delete in api)
  function useDeleteOrder() {
    const queryClient = useQueryClient();
    return useMutation({
      mutationFn: async (OrderDetailsId: string) => {
        //send api update request here
        //await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
        //return Promise.resolve();      
        return await AxiosInstance.delete('order/' + OrderDetailsId)
          .then(function (response) {
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      //client side optimistic update
      onMutate: (OrderDetailsId: string) => {
        queryClient.setQueryData(['Orders'], (prevOrders: any) =>
          prevOrders?.filter((OrderDetails: IOrderHeader) => OrderDetails.id !== OrderDetailsId),
        );
      },
      //    onSettled: () => queryClient.invalidateQueries({ queryKey: ['Orders'] }), //refetch Orders after mutation, disabled for demo
    });
  }

  //READ hook (get Orders from api)
  function useGetOrders() {
    return useQuery<OrdersHeader>({
      queryKey: ['ordersDetails'],
      queryFn: async () => {
        //send api request here
        let tmpUrl = 'order/findAll';
        if (showComlete) tmpUrl = 'order/findAllComplete';
        return await AxiosInstance({
          // url of the api endpoint (can be changed)
          url: tmpUrl,
          method: "GET",
        }).then((res) => {
          // handle success
          const AllData = res.data as IOrderHeader[];

          const tmpTaskDataUser = AllData.filter((dt) => {
            if (LocalUserRoleId.current === 6) return true;
            else {
              if (dt.userId === userinfo.id || dt.userId === 1) // unassigned
              {
                if (dt.roleId === LocalUserRoleId.current)
                  return true;
              }
              return false;
            }
          })

          return tmpTaskDataUser as IOrderHeader[];
        });
      },
      refetchOnWindowFocus: 'always',
    });
  }
  //call UPDATE hook
  const { mutateAsync: updateOrder, isPending: isUpdatingOrder } =
    useUpdateOrder();
  //call DELETE hook
  const { mutateAsync: deleteOrder, isPending: isDeletingOrder } =
    useDeleteOrder();



  //UPDATE action
  const handleSaveOrder: MRT_TableOptions<IOrderHeader>['onEditingRowSave'] = async ({
    values,
    table
  }) => {
    const newValidationErrors = validateOrder(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
    await updateOrder(values);
    table.setEditingRow(null); //exit editing mode
  };

  //DELETE action
  const openDeleteConfirmModal = async (row: MRT_Row<IOrderHeader>) => {
    if (window.confirm('Are you sure you want to delete this order?')) {
      await deleteOrder(row.original.id);
      refetch();
    }
  };


  const table = useMaterialReactTable({

    enableDensityToggle: false,
    enableHiding: false,
    enableColumnActions: false,
    enablePagination: true,
    enableBottomToolbar: true,
    enableRowActions: isAdmin,
    enableColumnFilters: isAdmin,
    enableColumnOrdering: false,
    enableColumnFilterModes: false,
    enableFilterMatchHighlighting: false,
    enableGlobalFilter: isAdmin || userinfo.userRoleName === 'Shipper',
    enableFullScreenToggle: false,
    autoResetPageIndex: false,
    //enableRowOrdering: isAdmin,
    enableSorting: isAdmin,
    //enableRowActions: isAdmin,
    columns,
    data: fetchedOrders,
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: isAdmin,
    getRowId: (row) => row.id,
    //enableRowDragging: isAdmin,
    onGlobalFilterChange: setGlobalFilter,
    initialState: {
      pagination: { pageSize: 50, pageIndex: 0 },
      density: 'compact',
    },


    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(odd) > td': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    // mrtTheme: (theme) => ({
    //   baseBackgroundColor: theme.palette.background.default, //change default background color
    // }),
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        navigate('orderlines/' + row.id);
      },
      sx: {
        cursor: 'pointer', //you might want to change the cursor too when adding an onClick
      },
    }),
    muiTableHeadCellProps: {
      //no useTheme hook needed, just use the `sx` prop with the theme callback
      sx: (theme) => (muiTableHeadCellPropsHelper),
    },
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        muiTableBodyCellPropsHelper
      },
    }),
    muiToolbarAlertBannerProps: isLoadingOrdersError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,


    onCreatingRowCancel: () => setValidationErrors({}),
    //onCreatingRowSave: handleCreateOrder,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveOrder,
    //optionally customize modal content
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Create New Order</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', color: "red" }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit Order</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '.2rem', textAlign: 'center' }}>

        <Tooltip title="Delete">
          <IconButton color="error" onClick={(event) => {
            event.stopPropagation();
            openDeleteConfirmModal(row)
          }}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="urgent">
          <IconButton color="success" onClick={(event) => {
            event.stopPropagation();
            _handlePriority(row);
          }}>
            <PriorityHighIcon style={{ color: 'orange' }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Reassign User">
          <IconButton color="success" onClick={(event) => {
            event.stopPropagation();
            handleOpenReassignUser(row);
          }}>
            <PersonIcon style={{ color: '#6495ED' }} />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    //import PermIdentityIcon from '@mui/icons-material/PermIdentity';
    renderTopToolbarCustomActions: ({ table }) => (
      <div>
        <Tooltip arrow title="select order">
          <IconButton onClick={() => navigate('orderlines/' + fetchedOrders[0].id)}>
            <ShoppingCartIcon />
          </IconButton>
        </Tooltip>
        <Tooltip arrow title="Refresh Data">
          <IconButton onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>
        <Tooltip arrow title="Sync Data">

          <IconButton
            disabled={userinfo.userRoleName === 'Administrator' ? false : true}
            size='large' onClick={() => SyncData()}>
            <CloudSyncIcon />
          </IconButton>
        </Tooltip>
        show complete
        <Checkbox
          title='show complete'
          id='showComplete'
          checked={showComlete}
          onClick={_handleShowComleteChange} />
        <Tooltip arrow title={globalFilter + "Clear filter"} >

          <IconButton
            disabled={userinfo.userRoleName === 'Administrator' ? false : true}
            size='large' onClick={resetState}>
            <SearchOffIcon style={{ color: globalFilter === undefined || globalFilter.length === 0 ? 'grey' : 'red' }} />
          </IconButton>
        </Tooltip>
        {userinfo.userRoleName === 'QC' || userinfo.userRoleName === 'Packer' ?
        <Stack>
          <TextField
            margin="dense"
            id="searchBasket"
            name="searchBasket"
            label="searchBasket"
            fullWidth
            variant="standard"
            value={searchBasketTxt}
            onChange={(e) => { searchBasketGotoOrder(e) }}
            onKeyDown={(e)=>{onKeysearchBasketGotoOrder(e)}}
          />
        </Stack>
        :<></>}
      </div>
    ),
    state: {
      isLoading: isLoadingOrders,
      isSaving: isUpdatingOrder || isDeletingOrder,
      showAlertBanner: isLoadingOrdersError,
      showProgressBars: isFetchingOrders,
      globalFilter,
    },
  });

  return <>
  <UsersDialog
      open={openUsers}
      rowId={usersRowId}

      handleReassignUser={handleReassignUser} 
      onClose={setOpenUsers}  
    ></UsersDialog>
    <MaterialReactTable table={table} />

  </>;
};

//UPDATE hook (put in api)
function useUpdateOrder() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (OrderDetails: IOrderHeader) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newOrderDetailsInfo: IOrderHeader) => {
      queryClient.setQueryData(['OrderDetails'], (prevOrders: any) =>
        prevOrders?.map((prevOrder: IOrderHeader) =>
          prevOrder.id === newOrderDetailsInfo.id ? newOrderDetailsInfo : prevOrder,
        ),
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['Orders'] }), //refetch Orders after mutation, disabled for demo
  });
}


const queryClient = new QueryClient();

const ExampleWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <Orders />
  </QueryClientProvider>
);

export default ExampleWithProviders;

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );

function validateOrder(OrderHeader: IOrderHeader) {
  return {
    OrderDetails: !validateRequired(OrderHeader.CUSTNAME)
      ? 'order Details is Required'
      : '',
    //OrderRemarks: !validateRequired(OrderHeader.ADDRESS) ? ' ADDRESS is Required' : '', 
  };
}
